// extracted by mini-css-extract-plugin
export var divider = "_hl-7";
export var itemsToggle = "_hl-8";
export var mergeModal = "_hl-1";
export var optionCard = "_hl-4";
export var radioGroup = "_hl-6";
export var radioOption = "_hl-0";
export var selected = "_hl-5";
export var shipmentOptions = "_hl-2";
export var tableOptions = "_hl-3";